import { FieldValues, Path, UseFormReturn } from "react-hook-form";

import { isRequired } from "../../../../../../common/helpers/validators";

import { useTranslate } from "@/common/hooks/useTranslate";
import { QuestionOutput } from "@/common/types/trpc";
import { FormDatePickerField } from "@/forms-design-system/FormDatePickerField";

interface QuestionFieldDateProps<T extends FieldValues> {
  form: UseFormReturn<T>;
  name: Path<T>;
  label: string;
  question: QuestionOutput;
}

export function QuestionFieldDate<T extends FieldValues>({
  name,
  form,
  label,
  question,
  ...rest
}: QuestionFieldDateProps<T>) {
  const { t } = useTranslate();

  return (
    <FormDatePickerField
      label={label}
      data-test="question-field-date"
      required={question.required}
      control={form.control}
      name={name}
      rules={[isRequired(question.required, t("common", "answerRequired"))]}
      {...rest}
    />
  );
}
